import { render, staticRenderFns } from "./BrightestPlanet.vue?vue&type=template&id=6a6c76d6&"
import script from "./BrightestPlanet.vue?vue&type=script&lang=ts&"
export * from "./BrightestPlanet.vue?vue&type=script&lang=ts&"
import style0 from "./BrightestPlanet.vue?vue&type=style&index=0&id=6a6c76d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports